<template>
  <div class="third-sdk-contain">
    <div class="h0-title">一部手机管旅游APP第三方SDK说明</div>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 11pt"
        >为保障部分独立功能的实现，使您能够使用和享受更多的服务及功能，我们会在应用中嵌入第三方的</span
      ><span style="font-family: 'Times New Roman'; font-size: 11pt">SDK</span
      ><span style="font-family: 宋体; font-size: 11pt">，我们将审慎评估</span
      ><span style="font-family: 'Times New Roman'; font-size: 11pt">SDK</span
      ><span style="font-family: 宋体; font-size: 11pt">的使用目的。</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 11pt">请您理解，第三方</span
      ><span style="font-family: 'Times New Roman'; font-size: 11pt">SDK</span
      ><span style="font-family: 宋体; font-size: 11pt"
        >的功能和服务是不断更新和发展的，其处理的数据类型等内容可能会因为功能或策略调整存在一定的变化，请以第三方公示的有关个人信息的介绍为准。</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Bugly</span
      ><span style="font-family: 宋体; font-size: 10.5pt">崩溃分析</span
      ><span
        style="width: 5.24pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span
        style="
          font-family: '等线 Light';
          font-size: 10.5pt;
          font-weight: normal;
        "
        >用户使用中发生崩溃时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >收集应用崩溃问题，保障</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">APP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">稳定性</span
      ><span
        style="width: 12.24pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      ><span
        style="width: 21pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、设备型号、系统版本、品牌、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">CPU</span
      ><span style="font-family: 宋体; font-size: 10.5pt">架构、名称、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、手机参数</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >），存储信息（读取外部存储</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 宋体; font-size: 10.5pt">写入外部存储）</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      ><span style="font-family: 宋体; font-size: 10.5pt">  </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://bugly.qq.com/v2/</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span
        style="
          background-color: #ffffff;
          font-family: 'Times New Roman';
          font-size: 10pt;
          font-weight: normal;
        "
        >https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Fresco</span
      ><span style="font-family: 宋体; font-size: 10.5pt">框架</span
      ><span
        style="width: 2.92pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >用户浏览图片时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提供网络图片加载能力</span
      ><span
        style="width: 10.5pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      ><span
        style="width: 21pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >存储信息（读取外部存储，写入外部存储），网络信息（访问网络</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Fresco  https://frescolib.org/
      </span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：暂无</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">TBS</span
      ><span style="font-family: 宋体; font-size: 10.5pt">浏览服务</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >用户浏览应用内页面时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >为用户提供应用内页面浏览能力</span
      ><span
        style="width: 10.5pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、设备型号、系统版本、品牌、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">CPU</span
      ><span style="font-family: 宋体; font-size: 10.5pt">架构、名称、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、设备系统构建</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >），存储信息（读取外部存储，写入外部存储）</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，应用信息（应用包名、应用版本号、运行状态），网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">TBS</span
      ><span style="font-family: 宋体; font-size: 10.5pt">浏览服务</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在前台静默和后台静默期间，可能会获取</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、设备系统构建信息、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >读取外部存储文件，写入外部存储文件，约一分钟收集一次，</span
      ><span style="font-family: 宋体; font-size: 10.5pt">用于为</span
      ><span style="font-family: 宋体; font-size: 10.5pt">用户</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提供一部手机管旅游平台页面浏览服务</span
      ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      ><span style="font-family: 宋体; font-size: 10.5pt">  </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://x5.tencent.com/</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >https://x5.tencent.com/docs.html#202403280001</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">移动推送</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >TPNS SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >推送消息时使用</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在移动终端设备进行消息推送</span
      ><span
        style="width: 21pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      ><span
        style="width: 21pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >厂商、机型、国家编码、系统版本、系统语言、手机型号、内核参数、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SDCard</span
      ><span style="font-family: 宋体; font-size: 10.5pt">信息、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >OAID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >存储信息（读取外部存储，写入外部存储），</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络类型</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址、运营商代号</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，账号绑定信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(QQopenID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、微信</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Union ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">手机号</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">移动推送</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >TPNS SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在前台静默和后台静默期间，可能会获取</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >OAID</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >网络信息、读取外部存储文件，约</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">0</span
      ><span style="font-family: 宋体; font-size: 10.5pt">秒</span
      ><span style="font-family: 宋体; font-size: 10.5pt">收集一次，用于</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >用户使用一部手机管旅游时接收业务办理消息推送</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提醒用户及时完成业务处理</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      ><span style="font-family: 宋体; font-size: 10.5pt">  </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://cloud.tencent.com/product/tpns</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: normal;
        "
        >https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >ApacheHTTPclient</span
      ><span style="font-family: 宋体; font-size: 10.5pt">支持</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">jar</span
      ><span style="font-family: 宋体; font-size: 10.5pt">包</span
      ><span
        style="width: 11.7pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >用户下载文件时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提供网络框架支撑能力</span
      ><span
        style="width: 10.5pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      ><span
        style="width: 21pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >），存储信息（读取外部存储）</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Apache  </span
      ><a style="color: #0563c1" href="http://www.apache.org/"
        ><span
          style="
            color: #0563c1;
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            text-decoration: underline;
          "
          >http://www.apache.org/</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://privacy.apache.org/policies/privacy-policy-public.html</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 11pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt">华为推送</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >推送消息时使用</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >为用户提供通知信息推送功能</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      ><span
        style="width: 21pt; text-indent: 0pt; display: inline-block"
      ></span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >，应用列表，获取任务信息，读取手机状态），存储信息（读取外部存储，写入外部存储）</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >华为软件技术有限公司</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://developer.huawei.com/consumer/cn/hms/huawei-pushkit</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><a
        style="color: #0563c1"
        href="https://consumer.huawei.com/cn/privacy/privacy-policy/"
        ><span
          style="
            background-color: #ffffff;
            color: #0563c1;
            font-family: 'Times New Roman';
            font-size: 10pt;
            text-decoration: underline;
          "
          >https://consumer.huawei.com/cn/privacy/privacy-policy/</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯地图</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >用户使用地图及定位相关服务时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >：为管理部门用户录入购物点时提供</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >购物店位置</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >信息，为导游到达行程地点时提供定位信息</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >OAID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、系统属性、操作系统及版本、手机屏幕密度和尺寸、操作系统及版本、系统设置、设备型号、读取手机状态、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Sim </span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >卡状态、设备运动数据、剪切板），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取近似位置、获取精确位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，存储信息（读取外部存储、写入外部存储），网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(Cell ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Wi-Fi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">参数、附近的</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">列表、连接的</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SSID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >BSSID)</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、蓝牙信息），传感器信息（重力传感器、陀螺仪传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">、加速度传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">、磁场传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、旋转矢量传感器），电话权限，网络运营商名称，手机制式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt"
        >和地图强相关的场景，包括</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >购物店位置定位</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >服务，在开启定位并在您同意授权获取定位时，会获取您的</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >实时位置</span
      ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt">腾讯地图</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在前台静默和后台静默期间，可能会获取</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息、</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取精确位置，获取近似位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，读取外部存储文件，写入外部存储文件，约一分钟收集一次，用于当用户使用定位功能，在移动终端设备向用户提供定位信息。</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://lbs.qq.com/</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://privacy.qq.com/document/preview/a10a8634f237464da9a95f4f07e73e40</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯定位</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >用户使用地图及定位相关服务时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >：为用户提供地图服务、出行服务、周边内容展示</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >OAID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、系统属性、操作系统及版本、手机屏幕密度和尺寸、操作系统及版本、系统设置、设备型号、读取手机状态、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Sim </span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >卡状态、设备运动数据</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、剪切板</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取近似位置、获取精确位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，存储信息（读取外部存储、写入外部存储），网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(Cell ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Wi-Fi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">参数、附近的</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">列表、连接的</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SSID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >BSSID)</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、蓝牙信息），传感器信息（重力传感器、陀螺仪传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">、加速度</span
      ><span style="font-family: 宋体; font-size: 10.5pt">传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt">、磁场传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、旋转矢量传感器），电话权限，网络运营商名称，手机制式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt"
        >和地图强相关的场景，包括</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >购物店位置定位</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >服务，在开启定位并在您同意授权获取定位时，会获取您的</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >实时位置</span
      ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt">腾讯定位</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在前台静默和后台静默期间，可能会获取</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址、</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取精确位置，获取近似位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息、</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >读取外部存储文件，写入外部存储文件，约一分钟收集一次，用于当用户使用定位功能，在移动终端设备向用户提供定位信息。</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://lbs.qq.com/</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://privacy.qq.com/document/preview/dbd484ce652c486cb6d7e43ef12cefb0</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >MTP </span
      ><span style="font-family: 宋体; font-size: 10.5pt">反外挂</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">安全加固</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >应用安全加固，提升应用安全性</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >、设备型号、系统版本、品牌、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">CPU</span
      ><span style="font-family: 宋体; font-size: 10.5pt">架构、</span
      ><span style="font-family: 宋体; font-size: 10.5pt">频率、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SIM</span
      ><span style="font-family: 宋体; font-size: 10.5pt">卡</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >MCC/MNC</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 宋体; font-size: 10.5pt">名称、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >），存储信息（读取外部存储文件、写入外部存储文件），应用信息（应用包名、应用版本号、运行状态），网络信息（访问网络</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">名称</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >MTP </span
      ><span style="font-family: 宋体; font-size: 10.5pt">反外挂</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在前台静默和后台静默期间，可能会获取</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >网络信息、读取外部存储文件，约一分钟收集一次，用于</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >用户使用一部手机管旅游时</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >安全加固，提升应用安全性</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <a
        style="color: #000000"
        href="https://www.anticheatexpert.com/#/doc-center/47019c9bb902d424632782311957ec29073f3ec4"
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >https://www.anticheatexpert.com/#/doc-center/47019c9bb902d424632782311957ec29073f3ec4</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><a
        style="color: #000000"
        href="https://www.anticheatexpert.com/#/doc-center/8fc4c1195346a2c74e472881bca42c4010698921"
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >https://www.anticheatexpert.com/#/doc-center/8fc4c1195346a2c74e472881bca42c4010698921</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯灯塔</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Beacon SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">数据分析</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提高数据链路时效性和准确性</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">MAC</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMSI</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMEI</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，设备型号，</span
      ><span style="font-family: 宋体; font-size: 10.5pt">语言、时区、</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >读取手机状态，陀螺仪传感器</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、设备系统构建</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >），存储信息（读取外部存储），</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >应用信息（应用包名、应用版本号、运行状态），</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt">腾讯灯塔</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >BeaconSDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >在前台静默和后台静默期间，可能会获取</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >网络信息，读取外部存储文件，约一分钟收集一次，用于当用户使用数据可视化功能时，在移动终端设备向用户提供数据可视化分析服务</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <a
        style="color: #000000"
        href="https://cloud.tencent.com/document/product/1558"
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >https://cloud.tencent.com/document/product/1558</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://privacy.qq.com/document/preview/a19a8cf4f2354306b137a7db39d32024</span
      >
    </p>
    <p style="margin: 3pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 3pt 0pt">
      <span
        style="color: #333333; font-family: 'Times New Roman'; font-size: 11pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >开发工具库</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >应用开发工具</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt">对</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"> </span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android </span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >系统提供标准新功能支持，使开发者能更轻松地面向更多设备进行开发和提供支持</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMEI</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >，应用软件列表），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt">（获取</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >精确位置</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt">，获取</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >近似位置</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >），权限信息（</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置权限</span
      ><span style="font-family: '等线 Light'; font-size: 10.5pt"
        >，相机权限，存储权限），存储信息（读取外部存储文件，写入外部存储文件）</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span
        style="font-family: '等线 Light'; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Google</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <a style="color: #0563c1" href="https://developer.android.google.cn/"
        ><span
          style="
            color: #0563c1;
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            text-decoration: underline;
          "
          >https://developer.android.google.cn/</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><a
        style="color: #0563c1"
        href="https://developer.android.google.cn/privacy"
        ><span
          style="
            color: #0563c1;
            font-family: 'Times New Roman';
            font-size: 12pt;
            text-decoration: underline;
          "
          >https://developer.android.google.cn/privacy</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 12pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯云</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">COS</span
      ><span style="font-family: 宋体; font-size: 10.5pt">文件上传服务</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >用户上传图片或文件时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提供文件上传及浏览能力</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >）存储信息（读取外部存储，写入外部存储）网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      ><span style="font-family: 宋体; font-size: 10.5pt"> </span>
    </p>
    <p style="margin: 5pt 0pt">
      <a style="color: #0563c1" href="https://cloud.tencent.com/product/cos"
        ><span
          style="
            color: #0563c1;
            font-family: 宋体;
            font-size: 12pt;
            text-decoration: underline;
          "
          >https://cloud.tencent.com/product/cos</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><a
        style="color: #0563c1"
        href="https://privacy.qq.com/document/preview/a76038ae5ee242d18d3a45a34cdd744c"
        ><span
          style="
            color: #0563c1;
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            text-decoration: underline;
          "
          >https://privacy.qq.com/document/preview/a76038ae5ee242d18d3a45a34cdd744c</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Flutter</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >用户进行投诉处置操作时</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提升应用的流畅度并实现优美的动画效果</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMEI</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >OAID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，应用软件列表），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取精确位置，获取近似位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，权限信息（</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置权限</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，相机权限，存储权限），存储信息（读取外部存储文件，写入外部存储文件）、剪切板</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Google</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <a style="color: #0563c1" href="https://flutter.dev/"
        ><span
          style="
            color: #0563c1;
            font-family: 宋体;
            font-size: 12pt;
            text-decoration: underline;
          "
          >https://flutter.dev/</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">暂无</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 12pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">腾讯</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >QIMEI SDK</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">数据分析</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提高数据链路时效性和准确性</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">MAC</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMSI</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMEI</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，设备型号，读取手机状态，设备系统构建信息），存储信息（读取外部存储），应用信息（应用包名、应用版本号、运行状态），网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">）</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >深圳市腾讯计算机系统有限公司</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://privacy.qq.com/document/preview/91754d6dd7824e3689f17782c580e06e</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 12pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Sentry</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">用户使用中发生崩溃时</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >手机应用崩溃问题，保证APP稳定性</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFA，IDFV，UUID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，获取任务信息，读取手机状态），存储信息（读取外部存储，写入外部存储），应用信息（应用包名、应用版本号、运行状态），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取近似位置、获取精确位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，网络类型（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">5G</span
      ><span style="font-family: 宋体; font-size: 10.5pt">、</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">），访问网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">(IP</span
      ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，访问</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">网络信息</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >(WiFi</span
      ><span style="font-family: 宋体; font-size: 10.5pt">状态</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">)</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Sentry</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://sentry.io/for/ios/?original_referrer=https%3A%2F%2Fwww.google.com%2F</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><a
        style="color: #0563c1"
        href="https://sentry.io/privacy/?original_referrer=https:/www.google.com/"
        ><span
          style="
            color: #0563c1;
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            text-decoration: underline;
          "
          >https://sentry.io/privacy/?original_referrer=https://www.google.com/</span
        ></a
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >webview</span
      ><span style="font-family: 宋体; font-size: 10.5pt">浏览器</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">用户浏览网页时</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提供网页浏览服务</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IMEI</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >Android ID</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，应用软件列表），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取精确位置，获取近似位置），</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >存储信息（读取外部存储文件，写入外部存储文件）、剪切板</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">谷歌</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">暂无</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >名称：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >WebKit</span
      ><span style="font-family: 宋体; font-size: 10.5pt">浏览器</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用场景：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">用户浏览网页时</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >使用目的：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >提供网页浏览服务</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >处理方式：</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >采用去标识化、加密传输和处理的安全处理方式</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集个人信息字段：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">设备信息（</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >IDFV</span
      ><span style="font-family: 宋体; font-size: 10.5pt">，设备类型），</span
      ><span
        style="
          font-family: 宋体;
          font-size: 14pt;
          font-weight: bold;
          text-decoration: underline;
        "
        >位置信息（获取精确位置，获取近似位置）</span
      ><span style="font-family: 宋体; font-size: 10.5pt"
        >，存储信息（读取外部存储文件，写入外部存储文件）、剪切板</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >收集方式：</span
      ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt">自主收集</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >提供主体：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">苹果</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >https://webkit.org/</span
      >
    </p>
    <p style="margin: 5pt 0pt">
      <span
        style="
          font-family: 'Times New Roman';
          font-size: 10.5pt;
          font-weight: bold;
        "
        >SDK</span
      ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
        >隐私政策：</span
      ><span style="font-family: 宋体; font-size: 10.5pt">暂无</span>
    </p>
    <p style="margin: 5pt 0pt">
      <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
        >&#xa0;</span
      >
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      authData: {}
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
    document.title = '第三方SDK目录';
  },

  created() {},
  beforeCreate() {
    document.title = '第三方SDK目录';
  }
};
</script>

<style scoped lang="less">
.under_line {
  text-decoration: underline;
}
.third-sdk-contain {
  padding: 0 12px 20px;
  word-break: break-all;
  p {
    line-height: 1.5;
  }

  .weight-big {
    font-weight: 700 !important;
  }

  .h0-title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-top: 24px;
  }

  .content {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 22px;
    margin-top: 12px;

    a {
      color: blue;
    }
  }

  .content-big {
    font-size: 16px;
  }

  .content-box {
    .h1-title {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
      margin-top: 16px;
    }

    .h1-box {
      .h2-title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        margin-top: 12px;
      }

      .h2-content {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        margin-top: 12px;
      }
    }
  }
}
</style>
